import { PlayerEvent } from '../PlayerEvent';
import { ReactComponent as QuickbackIcon } from '@crazyegginc/hatch/dist/images/icon-arrow-undo.svg';

export function NavigatedbackEvent({ timestamp, active, ...rest }) {
  return <PlayerEvent icon={QuickbackIcon} timestamp={timestamp} active={active} {...rest} title="Navigated back" />;
}
